import React from "react";
import "../styles/book.css";

export default ({ authorName, title, isbnNumber, description }) => (
  <div className="book">
    <div className="cover">
      <img
        alt={`${title} by ${authorName}`}
        src={`//covers.openlibrary.org/b/isbn/${isbnNumber}-M.jpg`}
      />
    </div>
    <main>
      <header>
        <h1>{title}</h1>
        <h2>{authorName}</h2>
      </header>
      <article>
        {description.map((paragraph, i) => (
          <p key={i}>{paragraph}</p>
        ))}
      </article>
    </main>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/Book.js